import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild } from '@angular/core'
import { OrgBrowserOrgList } from '../../../reports/models/org-browser-org-list'
import { OrgBrowserView } from '../../../reports/models/org-browser-view'
import { OrganizationDataGateway } from '../../../reports/gatewasys/organization-data.gateway'
import { OrgListNewComponent } from './org-list.component'

@Component({
    selector: 'org-list-container-new',
    templateUrl: './org-list-container.component.html',
    styleUrls: ['./org-list-container.component.scss']
})
export class OrgListContainerNewComponent implements OnInit {
    private _rootOrgId: number
    @Input('rootOrgId')
    get rootOrgId(): number {
        return this._rootOrgId
    }
    set rootOrgId(value: number) {
        this._rootOrgId = value
        //this.addOrgTreeNode(this._rootOrgId);
    }

    private _preSelectedOrgId: number
    @Input('preSelectedOrgId')
    get preSelectedOrgId(): number {
        return this._preSelectedOrgId
    }
    set preSelectedOrgId(value: number) {
        this._preSelectedOrgId = value
    }

    @Input() orgTree: OrgBrowserOrgList[]
    @Output() addOrgList: EventEmitter<number> = new EventEmitter()
    @Output() orgAdded: EventEmitter<OrgBrowserView> = new EventEmitter()
    @Output() orgTreeNodeAdded: EventEmitter<OrgBrowserView[]> = new EventEmitter()

    @ViewChild('orgListChild')
    private orgListChild: OrgListNewComponent

    constructor(private orgDataGateway: OrganizationDataGateway) {}

    ngOnInit() {
        this.orgTree = [] as OrgBrowserOrgList[]
    }

    initOrgTree(orgId: number): void {
        this.orgTree = [] as OrgBrowserOrgList[]
        this._rootOrgId = orgId
        this.addOrgTreeNode(orgId, false, false, true)
    }

    refreshOrgTree(rootOrgId: number, selectRoot: boolean, activeOnly: boolean = false): void {
        this.orgTree = [] as OrgBrowserOrgList[]
        this._rootOrgId = rootOrgId
        this.addOrgTreeNode(rootOrgId, selectRoot, activeOnly)
    }

    orgUnSelect(org: OrgBrowserView): void {
        this.orgTree.forEach((ot) => {
            const orgsFound = ot.organizations.filter((o) => o.orgId === org.orgId)
            orgsFound.forEach((o) => (o.selected = false))
        })
    }

    onOrgExpanded(org: OrgBrowserView): void {
        let addOrg: boolean = true
        if (this.orgTree !== undefined || this.orgTree !== null) {
            this.orgTree.forEach((ot) => {
                if (ot.currentOrganization !== undefined && ot.currentOrganization !== null) {
                    if (ot.currentOrganization.orgId === org.orgId) {
                        addOrg = false
                    }
                }
            })
        }
        if (addOrg === true) {
            this.addOrgTreeNode(org.orgId)
        }
    }

    onOrgCollapsed(org: OrgBrowserView): void {
        this.removeOrgTreeNode(org)
    }

    addRootOrgTreeNode(org: OrgBrowserView): void {
        const childOrgs: OrgBrowserView[] = [org] as OrgBrowserView[]
        org.expanded = true
        const orgList: OrgBrowserOrgList = {
            currentOrganization: undefined,
            organizations: childOrgs,
            selectedOrganization: org
        } as OrgBrowserOrgList
        this.orgTreeNodeAdded.emit(childOrgs)
        this.orgTree = this.orgTree.concat([orgList])
    }

    addOrgTreeNode(orgId: number, selectAll: boolean = false, activeOnly: boolean = false, initialize: boolean = false): void {
        this.orgDataGateway.getOrganization(orgId).subscribe((currentOrg) => {
            if (initialize) {
                const currentOrgCopy = Object.assign({}, currentOrg)
                this.addRootOrgTreeNode(currentOrgCopy)
            }
            this.orgDataGateway.getOrganizationsForParent(orgId).subscribe((childOrgs) => {
                const orgList: OrgBrowserOrgList = {
                    currentOrganization: currentOrg,
                    organizations: childOrgs,
                    selectedOrganization: undefined
                } as OrgBrowserOrgList
                if (activeOnly === true) {
                    childOrgs = childOrgs.filter((o) => o.isActive === true)
                }
                this.orgTreeNodeAdded.emit(childOrgs)
                this.orgTree = this.orgTree.concat([orgList])
                if (selectAll === true) {
                    orgList.organizations.forEach((o) => {
                        o.selected = true
                        this.onOrgAdd(o)
                    })
                }
            })
        })
    }

    removeOrgTreeNode(org: OrgBrowserView): void {
        const pos =
            this.orgTree
                .filter((o) => o.currentOrganization != null)
                .map((e) => e.currentOrganization?.orgId)
                .indexOf(org.orgId) + 1
        while (this.orgTree.length > pos) {
            this.orgTree[this.orgTree.length - 1].organizations.forEach((o) => (o.selected = false))
            this.orgTree.length = this.orgTree.length - 1
        }
    }

    onOrgAdd(org: OrgBrowserView): void {
        this.orgAdded.emit(org)
    }

    removeOrg(org: OrgBrowserView): void {}

    clearSearch(): void {
        this.orgTree = [] as OrgBrowserOrgList[]
    }
}
